import { EHorizontalProgressBarVariant } from "./horizontal-progress-bar.types"

const mainPartBgColorMap: {
    [K in EHorizontalProgressBarVariant]: (isActive: boolean, isParentNotAccented: boolean) => string
} = {
    [EHorizontalProgressBarVariant.Light]: (isActive: boolean, isParentNotAccented: boolean): string =>
        isActive ? "bg-blue-400" : isParentNotAccented ? "bg-blue-500" : "bg-white",
    [EHorizontalProgressBarVariant.Dark]: (isActive: boolean, _isParentNotAccented: boolean): string =>
        isActive ? "bg-gray-300" : "bg-gray-400"
}

const progressPartBgColorMap: { [K in EHorizontalProgressBarVariant]: (isActive: boolean) => string } = {
    [EHorizontalProgressBarVariant.Light]: (isActive: boolean): string => (isActive ? "bg-blue-200" : "bg-blue-300"),
    [EHorizontalProgressBarVariant.Dark]: (isActive: boolean): string => (isActive ? "bg-gray-23" : "bg-gray-300")
}

const HORIZONTAL_BAR_MINIMUM_VALUE = 5

const config = {
    mainPartBgColorMap,
    progressPartBgColorMap,
    HORIZONTAL_BAR_MINIMUM_VALUE
}

export { config as horizontalProgressBarConfig }
